// Module Import
import {combineReducers, createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';

// Reducers & Combine
import {userReducer} from './reducers/user';
import {gameMngtReducer} from './reducers/gameManagement';
import {matchMngtReducer} from './reducers/matchManagement';
import {historyReducer} from './reducers/history';

const rootReducer = combineReducers({
    user: userReducer,
    gameMngt: gameMngtReducer,
    match: matchMngtReducer,
    history: historyReducer
});

// export default createStore(loginReducer);
export default createStore(rootReducer, applyMiddleware(thunk));


// WEBPACK FOOTER //
// ./src/store.js